import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { AddressInterface } from "../../Entity/Entities/Address/AddressInterface";
import AddressFactory from "../../Entity/Factories/AddressFactory";

export default function* addressCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_ADDRESS_CREATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_ADDRESS_CREATE_REQUEST
    });

    const res = yield call(Http.post, `addresses`, action.payload);

    const address: AddressInterface = AddressFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_ADDRESS_CREATE_SUCCESS,
      payload: {
        address: address
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, address);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_ADDRESS_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchAddressCreate() {
  yield takeEvery(Constants.GLOBAL_ADDRESS_CREATE_START, addressCreate);
}
